<style>
    .table-dashboard thead tr td {
        background: #1f2248;
        color: #fff;
    }
    </style>
    <template>
        <zen-one
            :showuserinfo="false"
            title="Laporan Kutipan Cukai Semasa Mengikut Daerah"
            :crumbs="crumbs"
        >
            <z-page title="Laporan Kutipan Cukai Semasa Mengikut Daerah">
                <w-form ref="dform" @validate="search">
                    <w-flex class="mt3">
                        <div class="xs6 mr3">
                            <w-input
                                v-model="cari.tarikh_dari"
                                required
                                label="Dari"
                                type="date"
                            />
                            <!-- <z-lookup
                                label="Jabatan"
                                :url="service_utiliti + 'lookup/jabatan'"
                                :sort="false"
                                :cache="false"
                                v-model="cari.jabatan_id"
                            /> -->
                        </div>
                        <div class="xs6 mr3">
                            <w-input
                                v-model="cari.tarikh_hingga"
                                required
                                label="Hingga"
                                type="date"
                            />
                        </div>
                    </w-flex>
                </w-form>
    
                <w-flex class="mt1 mb3" justify-end>
                    <div class="mt2 text-right">
                        <w-button
                            class="ml1"
                            v-on:click="reset()"
                            bg-color="warning"
                        >
                            <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                        </w-button>
                        <w-button class="ml1" @click="$refs.dform.validate()">
                            <w-icon>fal fa-search</w-icon>&nbsp;Cari
                        </w-button>
                    </div>
                </w-flex>
    
                <w-flex justify-center align-center class="mt5">
                    <div class="w-card__content content-hardcode" style="overflow-x:auto;">
                        <table class="table-dashboard" width="100%" :loading="loading">
                            <thead>
                                <tr>
                                    <td rowspan="2">Bil</td>
                                    <td rowspan="2">Daerah</td>
                                    <td colspan="3">Bil</td>
                                    <td colspan="3">Cukai Tanah (RM)</td>
                                    <td colspan="3">Tunggakan Cukai Tanah (RM)</td>
                                    <td colspan="3">Cukai Tali Air (RM)</td>
                                    <td colspan="3">Tunggakan Cukai Tali Air (RM)</td>
                                    <td colspan="3">Denda (RM)</td>
                                    <td colspan="3">Tunggakan Denda (RM)</td>
                                    <td colspan="3">Jumlah (RM)</td>
                                </tr>
                                <tr>
                                    <td>Patut Kutip</td>
                                    <td>Telah Kutip</td>
                                    <td>Baki Perlu Kutip</td>
                                    
                                    <td>Patut Kutip</td>
                                    <td>Telah Kutip</td>
                                    <td>Baki Perlu Kutip</td>
                                    
                                    <td>Patut Kutip</td>
                                    <td>Telah Kutip</td>
                                    <td>Baki Perlu Kutip</td>
                                    
                                    <td>Patut Kutip</td>
                                    <td>Telah Kutip</td>
                                    <td>Baki Perlu Kutip</td>
                                    
                                    <td>Patut Kutip</td>
                                    <td>Telah Kutip</td>
                                    <td>Baki Perlu Kutip</td>
                                    
                                    <td>Patut Kutip</td>
                                    <td>Telah Kutip</td>
                                    <td>Baki Perlu Kutip</td>
                                    
                                    <td>Patut Kutip</td>
                                    <td>Telah Kutip</td>
                                    <td>Baki Perlu Kutip</td>
                                    
                                    <td>Patut Kutip</td>
                                    <td>Telah Kutip</td>
                                    <td>Baki Perlu Kutip</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="!table.meta.current_page">
                                    <td colspan="30" style="text-align:center;"><w-progress class="ma1" circle></w-progress></td>
                                </tr>
                                <tr v-for="(dt, index) in table.items">
                                    <td>{{ dt.no }}</td>
                                    <td>{{ dt.keterangan }}</td>
    
                                    <td>{{ dt.bil_patut_kutip }}</td>
                                    <td>{{ dt.bil_telah_kutip }}</td>
                                    <td>{{ dt.bil_baki_kutip }}</td>
    
                                    <td style="text-align:right;">{{ dt.cukai_patut_kutip }}</td>
                                    <td style="text-align:right;">{{ dt.cukai_telah_kutip }}</td>
                                    <td style="text-align:right;">{{ dt.cukai_baki_kutip }}</td>
    
                                    <td style="text-align:right;">{{ dt.tung_cukai_patut_kutip }}</td>
                                    <td style="text-align:right;">{{ dt.tung_cukai_telah_kutip }}</td>
                                    <td style="text-align:right;">{{ dt.tung_cukai_baki_kutip }}</td>
    
                                    <td style="text-align:right;">{{ dt.cuk_tali_patut_kutip }}</td>
                                    <td style="text-align:right;">{{ dt.cuk_tali_telah_kutip }}</td>
                                    <td style="text-align:right;">{{ dt.cuk_tali_baki_kutip }}</td>
    
                                    <td style="text-align:right;">{{ dt.tung_cuk_tali_patut_kutip }}</td>
                                    <td style="text-align:right;">{{ dt.tung_cuk_tali_telah_kutip }}</td>
                                    <td style="text-align:right;">{{ dt.tung_cuk_tali_baki_kutip }}</td>
    
                                    <td style="text-align:right;">{{ dt.denda_patut_kutip }}</td>
                                    <td style="text-align:right;">{{ dt.denda_telah_kutip }}</td>
                                    <td style="text-align:right;">{{ dt.denda_baki_kutip }}</td>
    
                                    <td style="text-align:right;">{{ dt.tung_denda_patut_kutip }}</td>
                                    <td style="text-align:right;">{{ dt.tung_denda_telah_kutip }}</td>
                                    <td style="text-align:right;">{{ dt.tung_denda_baki_kutip }}</td>
    
                                    <td style="text-align:right;">{{ dt.jumlah_patut_kutip }}</td>
                                    <td style="text-align:right;">{{ dt.jumlah_telah_kutip }}</td>
                                    <td style="text-align:right;">{{ dt.jumlah_baki_kutip }}</td>
                                </tr>
                                <tr v-if="table.meta.current_page && table.items.length == 0">
                                    <td colspan="30" style="text-align:center;">Tiada rekod dijumpai.</td>
                                </tr>
                            </tbody>
                        </table>
                        <w-card class="text-right">
                            <w-flex
                                v-if="table.meta.current_page"
                                class="justify-start align-center"
                            >
                                <pagination
                                    class="xs11"
                                    :max="table.meta.last_page"
                                    :path="table.meta.path"
                                    :current="table.meta.current_page"
                                    :last_page="table.meta.last_page"
                                    :links="table.meta.links"
                                    @pageChanged="table.loadpg"
                                />
                            </w-flex>
                        </w-card>
                    </div>
                </w-flex>
    
                <w-flex class="mt1 mb3" justify-center>
                    <div class="mt2 text-center">
                        <w-button bg-color="success" id="cetak" class="mr3" @click="cetak()">
                            <w-icon>fal fa-print</w-icon>&nbsp;Cetak
                        </w-button>
                    </div>
                </w-flex>
            </z-page>
        </zen-one>
    </template>
    
    <script>
    import { reactive } from "vue";
    import ZenOne from "@/Shared/ZenOne";
    import ZResource from "@/Modules/z-resource-service";
    
    export default {
        extends: ZResource,
        components: {
            // ZenOne
        },
        props: {
            items: [Array, Object],
            auth: [Array, Object],
        },
        data() {
            return {
                resourceurl: this.service_laporan + "kutipan/laporan/cukai_semasa_daerah",
                reload: true,
                status: [
                    {
                        value: 1,
                        label: "Aktif",
                    },
                    {
                        value: 2,
                        label: "Tidak Aktif",
                    },
                ],
                crumbs: [
                    { label: "iHasil", route: "/" },
                    { label: "Cukai Tanah", route: "/cukai-tanah/laporan/kutipan_semasa_daerah"},
                    { label: "Laporan", route: "/cukai-tanah/laporan/kutipan_semasa_daerah"},
                    {
                        label: "Laporan Kutipan Cukai Semasa Mengikut Daerah",
                        route: "/cukai-tanah/laporan/kutipan_semasa_daerah",
                    },
                ],
                cari: { tarikh_dari: "", tarikh_hingga: "", jabatan_id: "" },
            };
        },
        methods: {
            search() {
                this.$inertia.visit(
                    window.route("cukai-tanah.laporan.kutipan_semasa_daerah") + 
                        "?tarikh_dari=" + this.cari.tarikh_dari +
                        "&tarikh_hingga=" + this.cari.tarikh_hingga,
                    { preserveScroll: true }
                );
            },
    
            reset() {
                this.cari = { tarikh_dari: "", tarikh_hingga: "", jabatan_id: "" };
                this.search();
            },
    
            cetak() {
                document.getElementById("cetak").disabled = true;
                window.open(this.service_laporan+'kutipan/laporan/cukai_semasa_daerah/cetak?user_id='+this.auth.user.id+
                "&tarikh_dari=" + this.cari.tarikh_dari +
                "&tarikh_hingga=" + this.cari.tarikh_hingga,'_blank');
            },
        },
        watch: {},
        mounted() {
            // console.log(this.datas);
            this.dialog.width = 900;
            this.cari = location.search
                .slice(1)
                .split("&")
                .map((p) => p.split("="))
                .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
            if (this.cari.tarikh_dari == "undefined") {
                this.cari.tarikh_dari = "";
            }
            if (this.cari.tarikh_hingga == "undefined") {
                this.cari.tarikh_hingga = "";
            }
            if (this.cari.jabatan_id == "undefined") {
                this.cari.jabatan_id = "";
            }
            // console.log(this.auth.user.id);
        },
    };
    </script>
    <style>
    .w-select__menu {
        z-index: 999999;
    }
    </style>
    